module.exports = __webpack_public_path__ + "nm-icons_ed0f962e28326130e817dc0e4d267a8b.ttf?ce8d7ea1853858da3bd79d463490364c";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/iconfont/nm-icons_ed0f962e28326130e817dc0e4d267a8b.ttf
// module id = 1382
// module chunks = 33